import { ChakraProvider, createStandaloneToast } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';

import { AppRoutes } from './routes/index.routes';
import { AppRouterProvider } from './shared';
import i18n from './shared/config/i18n';
import { queryClient } from './shared/config/queryClient';
import { theme } from './shared/config/theme';

const { ToastContainer } = createStandaloneToast({
  defaultOptions: {
    position: 'top-right',
  },
});

function App() {
  return (
    <>
      <ToastContainer />
      <ChakraProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <AppRouterProvider>
              <AppRoutes />

              <ReactQueryDevtools
                initialIsOpen={false}
                position="bottom-right"
              />
            </AppRouterProvider>
          </QueryClientProvider>
        </I18nextProvider>
      </ChakraProvider>
    </>
  );
}

export default App;
